import axios from 'axios'

const instance = axios.create({
  baseURL: 'https://train-graph-rs-api.reges-services.se'
})

export default instance
